<template>
  <div class="update-config-wrapper">
    <UpdateConfigFileSelector
      @is-json-file-change="isJsonFile = $event"
      @new-config-change="onNewConfigChange"
    />
    <ts-text-field
      v-if="deltaData"
      label="Label/Reason"
      :value="updateReason"
      @input="onReasonChange"
      :readonly="isConfigApplied"
      multiline
      placeholder="You can explain here, why you are doing these changes..."
    />
    <TenantConfigurationDeltaView
      :delta-data="deltaData"
      :new-config="newConfig"
      :is-json-file="isJsonFile"
      :loading-diff-viewer="loadingDiffViewer"
      :is-config-applied="isConfigApplied"
      @apply-config-update-plan="applyExecutablePlan"
    />
  </div>
</template>

<script>
import TenantConfigurationDeltaView from './Configuration/TenantConfigurationDeltaView';
import UpdateConfigFileSelector from './Configuration/UpdateConfigFileSelector';
import {
  applyCompanyConfigDeltaExecutablePlan,
  getDeltaFromCompanyConfig,
} from '../../../api';
import { SUPPORTED_CONFIG_FILE_TYPES } from '../../../constants';

export default {
  components: { TenantConfigurationDeltaView, UpdateConfigFileSelector },
  provide() {
    const configUpdateProvidedData = {};
    Object.defineProperty(configUpdateProvidedData, 'isApplyingDeltaPlan', {
      enumerable: true,
      get: () => this.isApplyingDeltaPlan,
    });
    return { configUpdateProvidedData };
  },
  props: {
    tenant: { type: Object, default: null },
  },
  emits: ['task-created'],
  data() {
    return {
      loadingDiffViewer: false,
      isApplyingDeltaPlan: false,
      isConfigApplied: false,
      newConfig: null,
      deltaData: null,
      isJsonFile: false,
      updateReason: '',
    };
  },
  computed: {
    fileType() {
      return this.isJsonFile
        ? SUPPORTED_CONFIG_FILE_TYPES.JSON
        : SUPPORTED_CONFIG_FILE_TYPES.YAML;
    },
  },
  methods: {
    onNewConfigChange({ newConfig, hasFileTypeChanged }) {
      this.isConfigApplied = false;
      this.deltaData = null;
      this.newConfig = newConfig;
      if (newConfig) {
        this.getExecutablePlan(newConfig);
      }
    },
    getExecutablePlan(newConfig) {
      this.loadingDiffViewer = true;
      getDeltaFromCompanyConfig(
        this.tenant.CompanyAccountId,
        newConfig,
        this.fileType
      )
        .then((data) => {
          this.deltaData = data;
        })
        .finally(() => {
          this.loadingDiffViewer = false;
        });
    },
    applyExecutablePlan() {
      this.isApplyingDeltaPlan = true;
      applyCompanyConfigDeltaExecutablePlan(
        this.tenant.CompanyAccountId,
        this.deltaData.executablePlan,
        this.updateReason
      )
        .then((data) => {
          this.$emit('task-created', data.taskId);
        })
        .finally(() => {
          this.isConfigApplied = true;
          this.isApplyingDeltaPlan = false;
        });
    },
    findIndexOfExecutableItem(compareItem) {
      return this.deltaData.executablePlan.findIndex(
        (actionItem) =>
          actionItem.fragmentId === compareItem.fragmentId &&
          actionItem.action === compareItem.action
      );
    },
    onReasonChange(event) {
      if (event?.detail?.id) {
        this.updateReason = event?.detail?.value;
      }
    },
  },
};
</script>

<style scoped>
.update-config-wrapper {
  padding: var(--ts-unit);
  margin-bottom: var(--ts-unit);
}
</style>
